const productBundleButtonMain = document.querySelector('buy-buttons .button');
const productStickyATCMain = document.querySelector('.product-sticky-atc');
const productStickyButtonMain = productStickyATCMain.querySelector('.button');

/* STICKY ATC */

productStickyButtonMain.addEventListener('click', () => {
  productBundleButtonMain.click();
})

document.addEventListener('scroll', () => {
  if(window.innerWidth < 750){
    if(window.scrollY > 1200){
      productStickyATCMain.setAttribute('open', '');
    }else{
      productStickyATCMain.removeAttribute('open');
    }
  }else{
    if(window.scrollY > 750){
      productStickyATCMain.setAttribute('open', '');
    }else{
      productStickyATCMain.removeAttribute('open');
    }
  }
})